import styled from 'styled-components'; // unstyled placeholder for applying styles in a controlled manner via the cascade

var HoverText = styled("span").withConfig({
  displayName: "HoverText",
  componentId: "sc-xcwlle-0"
})([""]);
export default HoverText;